import { Box, Button, Flex } from '@mantine/core';
import { useForm, schemaResolver } from '@mantine/form';
import { IconPlus } from '@tabler/icons-react';
import { ReactNode, useEffect } from 'react';
import { z, ZodType } from 'zod';

interface PanelBaseProps<T> {
  items: T[];
  addButtonLabel: string;
  validationSchema?: ZodType<T>;
  renderTableView: () => ReactNode;
  onAdd?: () => void;
}

export function PanelBase<T extends { id?: string; clientId: string }>({
  items,
  addButtonLabel,
  validationSchema,
  renderTableView,
  onAdd,
}: PanelBaseProps<T>) {
  const form = useForm<{ items: T[] }>({
    mode: 'uncontrolled',
    initialValues: { items },
    validate: validationSchema
      ? schemaResolver(z.array(validationSchema), { sync: true })
      : undefined,
  });

  useEffect(() => {
    form.setValues({ items });
  }, [items]);

  return (
    <Box>
      {renderTableView()}

      <Flex justify="space-between" mt="md">
        <Button variant="outline-black" leftSection={<IconPlus size={16} />} onClick={onAdd}>
          {addButtonLabel}
        </Button>
      </Flex>
    </Box>
  );
}
